export default __webpack_public_path__ + "static/media/WarpMarkText.31f68e0d.png";